import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrashModal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 69,
	height: 68,
	viewBox: "0 0 69 68",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_7966_21727)",
		children: /* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_7966_21727)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M29.9999 4.16699C26.9624 4.16699 24.4999 6.62942 24.4999 9.66699V15.5003H16.8703H11.8333H10.3333V18.5003H11.8333H16.8703H17.5937L20.0988 58.5832C20.2306 60.6913 21.9788 62.3337 24.0911 62.3337H44.9088C47.021 62.3337 48.7692 60.6913 48.901 58.5832L51.4062 18.5003H57.1666H58.6666V15.5003H57.1666H44.4999V9.66699C44.4999 6.62943 42.0375 4.16699 38.9999 4.16699H29.9999ZM41.4999 15.5003V9.66699C41.4999 8.28628 40.3806 7.16699 38.9999 7.16699H29.9999C28.6192 7.16699 27.4999 8.28628 27.4999 9.66699V15.5003H41.4999Z",
				fill: "url(#paint0_linear_7966_21727)"
			})
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_7966_21727",
			x: 6.33325,
			y: 1.16699,
			width: 60.3333,
			height: 70.167,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 2,
					dy: 3
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_7966_21727"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_7966_21727",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_7966_21727",
			x1: 13.7166,
			y1: .312576,
			x2: 68.9502,
			y2: 64.7871,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF8C8C" }), /* @__PURE__ */ _jsx("stop", {
				offset: .562838,
				stopColor: "#EB3636"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_7966_21727",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 68,
				height: 68,
				fill: "white",
				transform: "translate(0.5)"
			})
		})
	] })]
});
export default SvgTrashModal;
